import { buildURL, fetchWithAuth, paginateQueryParams, fetchPaginatedJSON } from "../util/fetch-utils";
function alertsFilterToQueryParams(filter) {
    const query = {};
    if (filter?.eventCategories !== undefined) {
        query["event_categories"] = filter.eventCategories.join(",");
    }
    return query;
}
export default class VelavuAPIAlerts {
    //This method returns all of an organization's alerts
    getAllAlerts(params, pagination) {
        const queryParams = paginateQueryParams(pagination, alertsFilterToQueryParams(params));
        const url = buildURL("/alerts", queryParams);
        return fetchPaginatedJSON(url);
    }
    //This method deletes a single alert
    deleteAlert(alertID) {
        return fetchWithAuth(`/alerts/${alertID}`, { method: "DELETE" });
    }
    //This method deletes all of an organization's alerts
    deleteAllAlerts(params) {
        const url = buildURL("/alerts", alertsFilterToQueryParams(params));
        return fetchWithAuth(url, { method: "DELETE" });
    }
}
//# sourceMappingURL=velavu-api-alerts.js.map